import { render, staticRenderFns } from "./saleKickedCoverSetting.vue?vue&type=template&id=2b424e37&scoped=true"
import script from "./saleKickedCoverSetting.vue?vue&type=script&lang=js"
export * from "./saleKickedCoverSetting.vue?vue&type=script&lang=js"
import style0 from "./saleKickedCoverSetting.vue?vue&type=style&index=0&id=2b424e37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b424e37",
  null
  
)

export default component.exports